// extracted by mini-css-extract-plugin
export default {"user-table":"User_user-table__PVZvG","user-table__action":"User_user-table__action__J80g6","user-table__action--button":"User_user-table__action--button__fQRtK"};